/* GJ88 TikTok-Shop theme — interactions */
(function () {
  'use strict';

  const $ = (s, ctx) => (ctx || document).querySelector(s);
  const $$ = (s, ctx) => Array.from((ctx || document).querySelectorAll(s));

  /* ---------- PDP slider dots ---------- */
  function initPdpSlider() {
    const slides = $('.pdp__slides');
    const dots = $$('.pdp__dot');
    if (!slides || !dots.length) return;
    slides.addEventListener('scroll', () => {
      const idx = Math.round(slides.scrollLeft / slides.clientWidth);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }, { passive: true });
  }

  /* ---------- PDP quantity stepper ---------- */
  function initQty() {
    $$('.pdp__qty').forEach((wrap) => {
      const input = $('input', wrap);
      const dec = wrap.querySelector('[data-qty="-"]');
      const inc = wrap.querySelector('[data-qty="+"]');
      const min = parseInt(input.min || '1', 10);
      const max = parseInt(input.max || '99', 10);
      dec && dec.addEventListener('click', () => {
        input.value = Math.max(min, parseInt(input.value || '1', 10) - 1);
      });
      inc && inc.addEventListener('click', () => {
        input.value = Math.min(max, parseInt(input.value || '1', 10) + 1);
      });
    });
  }

  /* ---------- Cart drawer (open/close) ---------- */
  function initCartDrawer() {
    const drawer = $('#cart-drawer');
    if (!drawer) return;
    const open = () => { drawer.classList.add('is-open'); document.body.classList.add('no-scroll'); };
    const close = () => { drawer.classList.remove('is-open'); document.body.classList.remove('no-scroll'); };
    $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); open(); }));
    $$('[data-cart-close]', drawer).forEach((b) => b.addEventListener('click', close));
    drawer.querySelector('.drawer__overlay')?.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  async function addToCart(form) {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }
  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function initProductForm() {
    const form = $('form[data-product-form]');
    if (!form) return;
    const buyNow = form.querySelector('[data-buy-now]');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitter = e.submitter;
      const willCheckout = submitter && submitter.hasAttribute('data-buy-now');
      submitter && submitter.setAttribute('aria-disabled', 'true');
      try {
        await addToCart(form);
        if (willCheckout) {
          window.location.href = '/checkout';
          return;
        }
        const cart = await getCart();
        updateCartCount(cart.item_count);
        const drawer = $('#cart-drawer');
        if (drawer) drawer.classList.add('is-open');
      } catch (err) {
        alert(err.message);
      } finally {
        submitter && submitter.removeAttribute('aria-disabled');
      }
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    const form = $('form[data-product-form]');
    if (!form) return;
    const data = window.__product;
    if (!data) return;
    const variantInput = form.querySelector('input[name="id"]');
    const priceEl = $('[data-pdp-price]');
    const compareEl = $('[data-pdp-compare]');
    const discountEl = $('[data-pdp-discount]');

    function updateFromSelection() {
      const selected = $$('[data-option-group]', form).map((g) => {
        const active = g.querySelector('.is-active');
        return active ? active.dataset.value : null;
      });
      const variant = data.variants.find((v) =>
        v.options.every((opt, i) => selected[i] == null || selected[i] === opt)
      );
      if (!variant) return;
      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          if (discountEl) {
            const off = Math.round((1 - variant.price / variant.compare_at_price) * 100);
            discountEl.textContent = '-' + off + '%';
            discountEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (discountEl) discountEl.style.display = 'none';
        }
      }
    }
    $$('[data-option-group]', form).forEach((group) => {
      group.addEventListener('click', (e) => {
        const sw = e.target.closest('[data-value]');
        if (!sw) return;
        $$('[data-value]', group).forEach((s) => s.classList.remove('is-active'));
        sw.classList.add('is-active');
        updateFromSelection();
      });
    });
  }

  function formatMoney(cents) {
    const n = (cents / 100);
    const fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: fmt
      }).format(n);
    } catch (e) {
      return n.toFixed(2);
    }
  }

  /* ---------- Flash sale countdown ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach((el) => {
      const target = new Date(el.dataset.countdown).getTime();
      if (!target) return;
      const dEl = el.querySelector('[data-d]');
      const hEl = el.querySelector('[data-h]');
      const mEl = el.querySelector('[data-m]');
      const sEl = el.querySelector('[data-s]');
      function tick() {
        const diff = Math.max(0, target - Date.now());
        const d = Math.floor(diff / 86400000);
        const h = Math.floor(diff / 3600000) % 24;
        const m = Math.floor(diff / 60000) % 60;
        const s = Math.floor(diff / 1000) % 60;
        if (dEl) dEl.textContent = String(d).padStart(2, '0');
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Autoplay video cards in viewport ---------- */
  function initVideoCards() {
    const videos = $$('.product-card video[data-autoplay]');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const v = entry.target;
        if (entry.isIntersecting) {
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.5 });
    videos.forEach((v) => io.observe(v));
  }

  /* ---------- Mark active bottom nav by current path ---------- */
  function initBottomNavActive() {
    const path = window.location.pathname;
    $$('.bottom-nav a').forEach((a) => {
      const href = a.getAttribute('href') || '';
      if (href === '/' && path === '/') a.classList.add('is-active');
      else if (href !== '/' && path.startsWith(href)) a.classList.add('is-active');
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initPdpSlider();
    initQty();
    initCartDrawer();
    initProductForm();
    initVariants();
    initCountdowns();
    initVideoCards();
    initBottomNavActive();
  });
})();
